import Image from "next/image";

export function WiestCamperLogo({
  className,
  width = 112,
  height = 30,
}: {
  className?: string;
  width?: number;
  height?: number;
}) {
  return (
    <Image
      src="/wiest-camper-logo.webp"
      alt="Wiest Camper Logo"
      width={width}
      height={height}
      priority
      aria-hidden="false"
      role="img"
      className={className}
    />
  );
}
